import React from "react";
import {
  Button, Card, Col, Form, Input, Row, Select, Alert, message
} from "antd";
import {
  UserAddOutlined, PhoneOutlined, MailOutlined,
  UsergroupAddOutlined, UserSwitchOutlined, LockOutlined
} from "@ant-design/icons";
import axios from "axios";
import api_url from "../../../utils/requestApi";
import ServerApi from "../../../utils/ServerApi";
import appConst from "../../../constents/app.const";

const { Option } = Select;

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
  }

  state = {
    allClub: [],
    otpStep: false,
    generatedOtp: null,
    loading: false,
    otpVerifying: false,
    error: null,
    formValues: {},
  };

  componentDidMount() {
    const serverApi = new ServerApi(appConst.apiUrl, null);
    serverApi.club_fetch(api_url.fetech_club, (res) => {
      if (res.success === 1) {
        this.setState({ allClub: res.assoc_on });
      }
    });
  }

  filterOption = (input, option) =>
    option.children.toLowerCase().includes(input.toLowerCase());

  handleGenerateOtp = async (values) => {
    const { password, con_password, user_name } = values;

    if (password !== con_password) {
      this.setState({ error: "Passwords do not match" });
      return;
    }

    this.setState({ loading: true, error: null, formValues: values });

    try {
      const res = await axios.get(
        `https://noapi.game96.live/api/user/log/generate-login-code/${user_name}?t=${Date.now()}`
      );

      if (res.data.success && res.data.code) {
        message.success("OTP generated successfully");
        this.setState({
          otpStep: true,
          generatedOtp: res.data.code,
        });
      } else {
        this.setState({ error: res.data.message || "OTP generation failed" });
      }
    } catch (err) {
      this.setState({
        error: err.response?.data?.message || "Network error. Please try again.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleConfirmRegistration = async () => {
    const { formValues } = this.state;
    const code = this.formRef.current?.getFieldValue("code");

    if (!code) {
      this.setState({ error: "Please enter the OTP code" });
      return;
    }

    const registrationData = {
      ...formValues,
      full_name: "0",
      sponsor: formValues.sponsor || "0",
      promo: formValues.promo || "0",
      code,
    };

    this.setState({ otpVerifying: true, error: null });

    try {
      await this.props.onSignup(registrationData);
      message.success("Account created successfully!");
      window.location.href = "/login";
    } catch (err) {
      this.setState({
        error: err?.message || "Registration failed",
      });
    } finally {
      this.setState({ otpVerifying: false });
    }
  };

  render() {
    const {
      otpStep, generatedOtp, loading, otpVerifying, error, allClub
    } = this.state;

    return (
      <Row>
        <Col xs={0} sm={0} md={0} lg={6} xl={6} />
        <Col xs={24} sm={24} md={24} lg={12} xl={12} style={{ background: "white" }}>
          <Card className="signup-form">
            <div className="login-header">
              <UserAddOutlined /> Sign Up
            </div>

            {this.props.authFail && (
              <Alert message={this.props.authFailMsg} type="error" showIcon />
            )}

            {error && (
              <Alert
                message={error}
                type="error"
                showIcon
                style={{ marginBottom: "10px" }}
                closable
                onClose={() => this.setState({ error: null })}
              />
            )}

            <Form
              ref={this.formRef}
              name="signup_form"
              onFinish={this.handleGenerateOtp}
              preserve={false}
              layout="vertical"
            >
              <Form.Item
                name="user_name"
                rules={[{ required: true, message: "Username required" }]}
              >
                <Input prefix={<UserAddOutlined />} size="large" placeholder="Username" />
              </Form.Item>

              <Form.Item
                name="mobile_number"
                rules={[{ required: true, message: "Mobile number required" }]}
              >
                <Input
                  prefix={<PhoneOutlined />}
                  type="tel"
                  size="large"
                  placeholder="Mobile Number"
                />
              </Form.Item>

              <Form.Item name="email" hidden>
                <Input prefix={<MailOutlined />} />
              </Form.Item>

              <Form.Item
                name="club_name"
                rules={[{ required: true, message: "Please select club" }]}
              >
                <Select
                  size="large"
                  placeholder="Select Club"
                  showSearch
                  filterOption={this.filterOption}
                >
                  {allClub.map((club, i) => (
                    <Option key={i} value={club.username}>
                      {club.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item name="sponsor">
                <Input
                  size="large"
                  prefix={<UserSwitchOutlined />}
                  placeholder="Sponsor"
                />
              </Form.Item>

              <Form.Item name="promo" hidden>
                <Input
                  size="large"
                  prefix={<UsergroupAddOutlined />}
                  placeholder="Promo ID"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: "Password required" }]}
              >
                <Input.Password
                  size="large"
                  prefix={<LockOutlined />}
                  placeholder="Password"
                />
              </Form.Item>

              <Form.Item
                name="con_password"
                rules={[{ required: true, message: "Confirm password required" }]}
              >
                <Input.Password
                  size="large"
                  prefix={<LockOutlined />}
                  placeholder="Confirm Password"
                />
              </Form.Item>

              {otpStep && (
                <>
                  <Alert
                    message={`Your OTP: ${generatedOtp}`}
                    type="success"
                    showIcon
                    style={{ marginBottom: "10px" }}
                  />
                  <Form.Item
                    name="code"
                    rules={[{ required: true, message: "Enter OTP" }]}
                  >
                    <Input size="large" placeholder="Enter OTP code" />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      block
                      loading={otpVerifying}
                      onClick={this.handleConfirmRegistration}
                    >
                      Confirm Registration
                    </Button>
                  </Form.Item>
                </>
              )}

              {!otpStep && (
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    block
                  >
                    Create Account
                  </Button>
                </Form.Item>
              )}
            </Form>
          </Card>
        </Col>
        <Col xs={0} sm={0} md={0} lg={6} xl={6} />
      </Row>
    );
  }
}

export default Signup;
